import { createAction } from '@kistler/skybase-ui/skybase-core/base/create-action'
import { getActionName } from '@/common/actions/utils'

export const TOGGLE_NAVIGATION_EXPANSION = getActionName('TOGGLE_NAVIGATION_EXPANSION')
export const toggleNavigationExpansion = (expansionItemId, newState = undefined) =>
  createAction(TOGGLE_NAVIGATION_EXPANSION, { newState, expansionItemId })
